.popover {
  min-width: 148px;
}

.label {
  color: var(--neutral-50);
}
